import { MarketAggregatesState, ModelRun } from './types';

// State management actions that take current state and return new state

export const toggleModelSelectionAction = (
  state: MarketAggregatesState,
  modelId: string,
): MarketAggregatesState => {
  const updatedModels = state.availableModels.map((model) =>
    model.id === modelId ? { ...model, isSelected: !model.isSelected } : model,
  );

  return {
    ...state,
    availableModels: updatedModels,
  };
};

export const updateModelRunsAction = (
  state: MarketAggregatesState,
  modelId: string,
  runs: ModelRun[],
): MarketAggregatesState => {
  const updatedModels = state.availableModels.map((model) =>
    model.id === modelId ? { ...model, selectedRuns: runs } : model,
  );

  return {
    ...state,
    availableModels: updatedModels,
  };
};

export const resetAllSelectionsAction = (state: MarketAggregatesState): MarketAggregatesState => ({
  ...state,
  availableModels: state.availableModels.map((model) => ({
    ...model,
    isSelected: false,
    selectedRuns: [],
  })),
});

export const setWeightTypeAction = (
  state: MarketAggregatesState,
  weightType: 'population' | 'wind_capacity' | 'solar_capacity',
): MarketAggregatesState => ({
  ...state,
  weightType,
  loading: true,
  error: null,
});
